<template>
    <div class='static-banner'>
        <div class='banner-content'>

            <div v-if="banner_details.customer_outlet == 'Y' && banner_details.child == ''" class="back-to-outlet" @click="backToOutlet">
                <i class="fa-light fa-house-blank"></i>
                <span class="home-text">Home</span>
            </div>
            <div v-else class='empty-div'></div>
            
            <div v-if="list_type == 'customer_list'">
                <div class="avenirLight" v-if="banner_details.customer_outlet == 'Y'">You are ordering for <span class="text">{{ banner_details.outlet_name }}</span> from <span class="text">My Products List</span>
                </div>
                <div class="avenirLight" v-else> You are ordering from <span class="text">My Products List</span> from the <span class="text">{{ banner_details.store_name }}</span> store
                </div>
            </div>
            <div v-else>
                <div v-if="banner_details.customer_outlet == 'Y'" class="avenirLight">
                    You are ordering for <span class="text">{{ banner_details.outlet_name }}</span>
                </div>
                <div v-else class="avenirLight">
                    You are ordering from our <span class="text">{{ banner_details.store_name }}</span> location.
                </div>
            </div>
            <div class='empty-div'></div>
        </div>
    </div>
</template>

<script>
import "@glidejs/glide/dist/css/glide.core.css";
import "@glidejs/glide/dist/css/glide.theme.css";
import Glide from '@glidejs/glide';
import {checkAuth} from "@/global/modules/functions.js";

export default {
    props: ['list_type'],
    data(){
        return{
            glide_instance_banner: null,
            banner_config: [],
            mobile_mode: false,
            screen_size_check_timeout: null,
            banner_details: {}
        }
    },
    methods: {
        openUrl(e, url) {
            if(e.ctrlKey) {
                return;
            } else {
                e.preventDefault();
                //this.$router.push(url);
                window.location.href = url
            }
        },
        setBannerMessages(){
            setTimeout(() => {
                    if(document.getElementById('banner_message_slider') != null){
                        this.glide_instance_banner = new Glide('#banner_message_slider',{type: 'carousel',
                            perView: 1, 
                            keyboard: false, 
                            autoplay: false, 
                            dragThreshold: false, 
                            animationDuration: 1500,
                            animationTimingFunc: 'ease-in-out'
                        }).mount();
                        // Ensure update only happens after mount
                        this.updateGlideInstance();
                    }
            }, 1);
        },
        async getBannerConfig() {
            let response = await fetch(`/api/banner-config`, {
                method: 'GET',
                credentials: 'include'
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                this.banner_config   = results.banner_config;
                if(this.banner_config.banner_messages.length > 0) {
                    this.setBannerMessages();
                    setTimeout(() => this.CheckMobileMode(), 1);
                }
                
            }
        },
        CheckMobileMode(){
            let canvas = document.getElementsByClassName('banner')[0];
            if(typeof canvas !== 'undefined'){
                new ResizeObserver(()=>{
                    clearTimeout(this.screen_size_check_timeout);

                    this.screen_size_check_timeout = setTimeout(() => { //Set timeout to stop ResizeObserver loop completed with undelivered notifications error
                        if(canvas.clientWidth <= 768){
                            this.mobile_mode = true;
                        }
                        else{
                            this.mobile_mode = false;
                        }
                        this.updateGlideInstance();
                    }, 1);
                }).observe(canvas);
            }
        },
        updateGlideInstance() {
            if ((!this.banner_config.is_animated && !this.mobile_mode) || (!this.banner_config.is_animated && this.mobile_mode && this.banner_config.banner_messages.length == 1)) {
                this.glide_instance_banner.update({
                    perView: this.banner_config.banner_messages.length,
                    autoplay: null, 
                });
            } else {
                this.glide_instance_banner.update({
                    perView: 1,
                    autoplay: '5000', 
                });
            }
        },
        async getBannerDetails() {
            let response = await fetch(`/api/banner-details`, {
                method: 'GET',
                credentials: 'include'
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                this.banner_details = results;
            } 
        },
        backToOutlet() {
            this.$router.push('/outlets');
        }
    },
    mounted(){
        this.getBannerDetails();
    },
    watch: {
        'list_type' : function() {
            if(this.list_type == 'customer_list') {
                this.getBannerDetails();
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.banner{
    background-color: #f2f2f2;
    color: black;
    text-align: center;
    font-size: 1.45rem;
    height: var(--banner-height);
    padding-top: 9px;
    box-sizing: border-box;

    @media(max-width: 1256px){
       padding-top: 7px;
       padding-bottom: 7px;
       height: auto;
       font-size: 1.2rem;
    }
    @media(max-width: 1064px){
       padding-top: 5px;
       padding-bottom: 5px;
       height: auto;
       font-size: 0.81rem;
    }
}

.banner-content{
    display: flex;
    max-width: 1600px;
    justify-content: space-between;
    margin: auto;
    align-items: center;
    height: 100%;
    gap: 24px;
    text-align: center;
}
.link{
    text-decoration: none;
    color: inherit;
}

.glide * {
   // cursor: pointer;
}

.static-banner{

    background-color: #F9F5F0;
    color: black;
    font-size: 1.2rem;
    height: var(--banner-height);
    // padding-top: 2px;
    // box-sizing: border-box;
    // gap: 80px;

        padding: 0px 48px; 
     @media(max-width: 1256px){
    //    height: auto;
       font-size: 1.2rem;
    }
    @media(max-width: 1064px){

    //    height: auto;
       font-size: 0.81rem;
    }
}
.text{
    font-weight: 600;
}
.back-to-outlet{
    cursor: pointer;
}

.home-text{
    font-size: 0.9rem;
    margin-left: 8px;

    &:hover{
        text-decoration: underline;
    }
}
</style>